<template>
  <div>
    <span
      v-for="billingStatusData of billingSummaryStatus"
      style="padding: 8px; font-weight: 700;"
    >
      {{ billingStatusData.name }}: {{ billingStatusData.total }};
      {{ billingStatusData.percentageOfTotal }}% |
    </span>
  </div>
</template>

<script>
/// <reference path="../types/index.js" />
export default {
  props: {
    /**
     * @type {BillingSummary[]}
     */
    billingSummaryStatus: {
      required: true,
      type: Array,
    },
  },
};
</script>
